import Env from "../base/env";
import Component from "gia/Component";
import { ScrollTrigger } from "../vendor/gsap-bonus-umd/ScrollTrigger";
import gsap from "gsap";
gsap.registerPlugin(ScrollTrigger);

export default class Module extends Component {
  constructor(element) {
    super(element);
    this.ref = {};
  }

  mount() {
    this.DOM = {};
    this.DOM.view = this.element;
    //
    this.listener();
  }

  listener() {
    this.stListener = ScrollTrigger.create({
      trigger: this.DOM.view,
      start: "top bottom",
      onEnter: () => Env.$html.classList.add("footer-inview"),
      onLeaveBack: () => Env.$html.classList.remove("footer-inview"),
      markers: false,
    });
  }

  unmount() {
    this.stListener.kill();
  }
}
